import React from 'react';
import locale from '../../Locale';
import { Container, Col, Row } from 'reactstrap';
import Helper from '../../Helper';

const CookieInfo: React.FunctionComponent<any> = (props) => {
	const lang = Helper.userLang();
	return (
		<Container className='cookies' style={{ padding: '20px', maxWidth: '100%', marginBottom: '100px' }}>
			{lang === 'sl' ? (
				<Row form>
					<Col md={8}>
						<Row form>
							<Col md={12} style={{ paddingBottom: '20px' }}>
								<h1>{locale.cookiesTitle}</h1>
								<p>
									Ta spletna stran za delovanje strani uporablja piškotke, ki ne hranijo osebnih podatkov in ne sledijo vašemu vedenju izven
									vzdrževanja povezave s spletno stranjo. Potrebni so za zagotavljanje zanesljive in varne izkušnje. Z uporabo spletne strani
									obiskovalci soglašajo z njihovo uporabo.
								</p>
							</Col>
						</Row>
						<Row form>
							<Col md={12} style={{ paddingBottom: '20px' }}>
								<h2>O piškotkih</h2>
								<p>
									Piškotki niso nič novega, vsi obiskovalci spletnih strani imamo na svojih računalnikih, tablicah in mobitelih shranjenih že veliko
									piškotkov z različnih spletnih strani. Novost je le v tem, da je z novo zakonodajo (ZEKom-1) prišlo do sprememb glede obveščanja oz.
									soglašanja obiskovalcev z njihovo uporabo.
								</p>
							</Col>
						</Row>
						<Row form>
							<Col md={12} style={{ paddingBottom: '20px' }}>
								<h2>Kaj so piškotki?</h2>
								<p>
									Piškotki so male besedilne datoteke, ki jih večina spletnih mest shrani v naprave, s katerimi uporabniki dostopajo do interneta, z
									namenom prepoznavanja posameznih naprav, ki so jih uporabniki uporabili pri dostopu. Njihovo shranjevanje je pod popolnim nadzorom
									brskalnika, ki ga ima uporabnik – ta lahko shranjevanje piškotkov po želji omeji ali onemogoči. Piškotki niso škodljivi in so vedno
									časovno omejeni.
								</p>
							</Col>
						</Row>
						<Row form>
							<Col md={12} style={{ paddingBottom: '20px' }}>
								<h2>Zakaj so piškotki potrebni?</h2>
								<p>
									Piškotki so temeljnega pomena za zagotavljanje uporabniku prijaznih spletnih storitev in zanesljive ter varne uporabniške izkušnje.
									Interakcija med spletnim uporabnikom in spletnim mestom je s pomočjo piškotkov hitrejša in enostavnejša.{' '}
								</p>
								<p>Nekaj konkretnih primerov uporabe piškotkov:</p>
								<ul>
									<li style={{ paddingBottom: '10px' }}>
										<b>za boljšo uporabniško izkušnjo spletne strani:</b> obiskovalcem omogočamo, da se vaši zahtevki med obiskom naše spletne strani
										vedno pošiljajo na isti strežnik. Tako zagotavljamo konsistentnost podatkov o vaši seji (npr. stanje prijave ali nastavitve),
										spletna stran pa deluje učinkoviteje, brez nepotrebnih preusmeritev ali prekinitev.
									</li>
									<li style={{ paddingBottom: '10px' }}>
										<b>za varno uporabniško izkušnjo: </b>piškotek pošiljamo samo pri zahtevkih, ki prihajajo neposredno z naše spletne strani. Na ta
										način zagotavljamo zaščito pred nepooblaščenimi zahtevki z drugih spletnih mest.
									</li>
								</ul>
								<p>
									Naša spletna stran uporablja naslednje <b>nujne</b> (funkcionalne) piškotke:
								</p>
								<table>
									<tr>
										<th>Ime piškotka</th>
										<th>Namen</th>
										<th>Trajanje piškotka</th>
										<th>Podjetje</th>
									</tr>
									<tr>
										<td>ARRAffinity</td>
										<td>Skrbi za pravilno delovanje MS Azure</td>
										<td>Do zaprtja brskalnika</td>
										<td>Microsoft Azure</td>
									</tr>
									<tr>
										<td>ARRAffinitySameSite</td>
										<td>Skrbi za pravilno delovanje MS Azure</td>
										<td>Do zaprtja brskalnika</td>
										<td>Microsoft Azure</td>
									</tr>
									<tr>
										<td>cookie_viewed</td>
										<td>Uporablja se za hranjenje informacije o tem, ali je obiskovalec videl obvestilo o piškotkih</td>
										<td>365 dni</td>
										<td>Varialis</td>
									</tr>
								</table>
							</Col>
						</Row>
					</Col>
				</Row>
			) : lang === 'en' ? (
				<Row form>
					<Col md={8}>
						<Row form>
							<Col md={12} style={{ paddingBottom: '20px' }}>
								<h1>{locale.cookiesTitle}</h1>
								<p>
									This website uses cookies for its operation, which do not store personal data and do not track your behavior outside of maintaining
									a connection with the website. These cookies are necessary to ensure a reliable and secure user experience. By using the website,
									visitors agree to the use of these cookies.
								</p>
							</Col>
						</Row>
						<Row form>
							<Col md={12} style={{ paddingBottom: '20px' }}>
								<h2>About Cookies</h2>
								<p>
									Cookies are nothing new. All visitors to websites already have many cookies stored on their computers, tablets, and mobile phones
									from various websites. What is new is that with the new legislation (ZEKom-1), changes have been introduced regarding informing
									visitors and obtaining their consent for their use.
								</p>
							</Col>
						</Row>
						<Row form>
							<Col md={12} style={{ paddingBottom: '20px' }}>
								<h2>What Are Cookies?</h2>
								<p>
									Cookies are small text files that most websites store on the devices users use to access the internet. Their purpose is to recognize
									individual devices that users used during access. The storage of cookies is fully under the control of the browser that the user has
									– users can limit or disable the storage of cookies as desired. Cookies are not harmful and are always time-limited.
								</p>
							</Col>
						</Row>
						<Row form>
							<Col md={12} style={{ paddingBottom: '20px' }}>
								<h2>Why Are Cookies Necessary?</h2>
								<p>
									Cookies are fundamental for providing user-friendly online services and a reliable and secure user experience. Interaction between a
									web user and a website is faster and easier with the help of cookies.
								</p>
								<p>
									<b>Some Specific Examples of Cookie Usage:</b>
								</p>
								<ul>
									<li style={{ paddingBottom: '10px' }}>
										<b>For a better user experience on the website: </b>We ensure that your requests during your visit to our website are always sent
										to the same server. This ensures the consistency of your session data (e.g., login state or preferences), and the website operates
										more efficiently without unnecessary redirects or interruptions.
									</li>
									<li style={{ paddingBottom: '10px' }}>
										<b>For a secure user experience: </b>The cookie is sent only for requests that come directly from our website. This ensures
										protection against unauthorized requests from other websites.
									</li>
								</ul>
								<p>
									<b>Our Website Uses the Following Necessary (Functional) Cookies:</b>
								</p>
								<table>
									<tr>
										<th>Cookie Name</th>
										<th>Purpose</th>
										<th>Cookie Duration</th>
										<th>Provider</th>
									</tr>
									<tr>
										<td>ARRAffinity</td>
										<td>Ensures proper functioning of MS Azure</td>
										<td>Until the browser is closed</td>
										<td>Microsoft Azure</td>
									</tr>
									<tr>
										<td>ARRAffinitySameSite</td>
										<td>Ensures proper functioning of MS Azure</td>
										<td>Until the browser is closed</td>
										<td>Microsoft Azure</td>
									</tr>
									<tr>
										<td>cookie_viewed</td>
										<td>Used to store information about whether the visitor has seen the cookie notification</td>
										<td>365 days</td>
										<td>Varialis</td>
									</tr>
								</table>
							</Col>
						</Row>
					</Col>
				</Row>
			) : lang === 'it' ? (
				<Row form>
					<Col md={8}>
						<Row form>
							<Col md={12} style={{ paddingBottom: '20px' }}>
								<h1>{locale.cookiesTitle}</h1>
								<p>
									Questo sito web utilizza cookie per il suo funzionamento, che non memorizzano dati personali e non tracciano il tuo comportamento al
									di fuori della connessione con il sito web. Questi cookie sono necessari per garantire un'esperienza utente affidabile e sicura.
									Utilizzando il sito web, i visitatori accettano l'uso di questi cookie.
								</p>
							</Col>
						</Row>
						<Row form>
							<Col md={12} style={{ paddingBottom: '20px' }}>
								<h2>Informazioni sui cookie</h2>
								<p>
									I cookie non sono una novità. Tutti i visitatori dei siti web hanno già molti cookie memorizzati sui loro computer, tablet e
									telefoni cellulari provenienti da vari siti web. La novità consiste nel fatto che, con la nuova legislazione (ZEKom-1), sono state
									introdotte modifiche in merito all'informativa e al consenso dei visitatori per il loro utilizzo.
								</p>
							</Col>
						</Row>
						<Row form>
							<Col md={12} style={{ paddingBottom: '20px' }}>
								<h2>Cosa sono i cookie?</h2>
								<p>
									I cookie sono piccoli file di testo che la maggior parte dei siti web memorizza sui dispositivi con cui gli utenti accedono a
									Internet. Il loro scopo è riconoscere i dispositivi utilizzati durante l'accesso. La memorizzazione dei cookie è completamente sotto
									il controllo del browser che l'utente utilizza – l'utente può limitare o disabilitare la memorizzazione dei cookie secondo le
									proprie preferenze. I cookie non sono dannosi e hanno sempre una durata limitata.
								</p>
							</Col>
						</Row>
						<Row form>
							<Col md={12} style={{ paddingBottom: '20px' }}>
								<h2>Perché sono necessari i cookie?</h2>
								<p>
									I cookie sono fondamentali per fornire servizi online user-friendly e un'esperienza utente affidabile e sicura. Grazie ai cookie,
									l'interazione tra l'utente e il sito web è più veloce e semplice.
								</p>
								<p>
									<b>Alcuni esempi specifici di utilizzo dei cookie:</b>
								</p>
								<ul>
									<li style={{ paddingBottom: '10px' }}>
										<b>Per una migliore esperienza utente sul sito web: </b>Garantiamo che le tue richieste durante la visita al nostro sito vengano
										sempre inviate allo stesso server. Ciò garantisce la coerenza dei dati della tua sessione (ad esempio, stato di accesso o
										preferenze) e il sito funziona in modo più efficiente senza reindirizzamenti o interruzioni inutili.
									</li>
									<li style={{ paddingBottom: '10px' }}>
										<b>Per un'esperienza utente sicura: </b>Il cookie viene inviato solo per richieste che provengono direttamente dal nostro sito
										web, garantendo così la protezione contro richieste non autorizzate provenienti da altri siti.
									</li>
								</ul>
								<p>
									<b>Il nostro sito web utilizza i seguenti cookie necessari (funzionali):</b>
								</p>
								<table>
									<tr>
										<th>Nome del cookie</th>
										<th>Scopo</th>
										<th>Durata del cookie</th>
										<th>Fornitore</th>
									</tr>
									<tr>
										<td>ARRAffinity</td>
										<td>Garantisce il corretto funzionamento di MS Azure</td>
										<td>Fino alla chiusura del browser</td>
										<td>Microsoft Azure</td>
									</tr>
									<tr>
										<td>ARRAffinitySameSite</td>
										<td>Garantisce il corretto funzionamento di MS Azure</td>
										<td>Fino alla chiusura del browser</td>
										<td>Microsoft Azure</td>
									</tr>
									<tr>
										<td>cookie_viewed</td>
										<td>Memorizza se il visitatore ha visto la notifica sui cookie</td>
										<td>365 giorni</td>
										<td>Varialis</td>
									</tr>
								</table>
							</Col>
						</Row>
					</Col>
				</Row>
			) : lang === 'de' ? (
				<Row form>
					<Col md={8}>
						<Row form>
							<Col md={12} style={{ paddingBottom: '20px' }}>
								<h1>{locale.cookiesTitle}</h1>
								<p>
									Diese Website verwendet Cookies für ihren Betrieb, die keine persönlichen Daten speichern und Ihr Verhalten außerhalb der Verbindung
									mit der Website nicht verfolgen. Diese Cookies sind notwendig, um eine zuverlässige und sichere Benutzererfahrung zu gewährleisten.
									Durch die Nutzung der Website stimmen Besucher der Verwendung dieser Cookies zu.
								</p>
							</Col>
						</Row>
						<Row form>
							<Col md={12} style={{ paddingBottom: '20px' }}>
								<h2>Über Cookies</h2>
								<p>
									Cookies sind nichts Neues. Alle Besucher von Websites haben bereits viele Cookies auf ihren Computern, Tablets und Mobiltelefonen
									gespeichert, die von verschiedenen Websites stammen. Neu ist, dass mit der neuen Gesetzgebung (ZEKom-1) Änderungen bezüglich der
									Information und Zustimmung der Besucher zu ihrer Verwendung eingeführt wurden.
								</p>
							</Col>
						</Row>
						<Row form>
							<Col md={12} style={{ paddingBottom: '20px' }}>
								<h2>Was sind Cookies?</h2>
								<p>
									Cookies sind kleine Textdateien, die die meisten Websites auf den Geräten speichern, mit denen Benutzer auf das Internet zugreifen.
									Ihr Zweck ist es, die einzelnen Geräte zu erkennen, die Benutzer beim Zugriff verwendet haben. Die Speicherung von Cookies liegt
									vollständig unter der Kontrolle des Browsers, den der Benutzer verwendet – der Benutzer kann die Speicherung von Cookies nach
									Belieben einschränken oder deaktivieren. Cookies sind nicht schädlich und immer zeitlich begrenzt.
								</p>
							</Col>
						</Row>
						<Row form>
							<Col md={12} style={{ paddingBottom: '20px' }}>
								<h2>Warum sind Cookies notwendig?</h2>
								<p>
									Cookies sind grundlegend, um benutzerfreundliche Onlinedienste sowie eine zuverlässige und sichere Benutzererfahrung zu
									gewährleisten. Die Interaktion zwischen einem Webnutzer und einer Website wird durch Cookies schneller und einfacher.
								</p>
								<p>
									<b>Einige konkrete Beispiele für die Verwendung von Cookies:</b>
								</p>
								<ul>
									<li style={{ paddingBottom: '10px' }}>
										<b>Für eine bessere Benutzererfahrung auf der Website: </b>Wir stellen sicher, dass Ihre Anfragen während Ihres Besuchs unserer
										Website immer an denselben Server gesendet werden. So wird die Konsistenz Ihrer Sitzungsdaten (z. B. Anmeldestatus oder
										Einstellungen) gewährleistet, und die Website funktioniert effizienter ohne unnötige Weiterleitungen oder Unterbrechungen.
									</li>
									<li style={{ paddingBottom: '10px' }}>
										<b>Für eine sichere Benutzererfahrung: </b>Der Cookie wird nur bei Anfragen gesendet, die direkt von unserer Website stammen. Dies
										schützt vor unbefugten Anfragen von anderen Websites.
									</li>
								</ul>
								<p>
									<b>Unsere Website verwendet die folgenden notwendigen (funktionalen) Cookies:</b>
								</p>
								<table>
									<tr>
										<th>Cookie-Name</th>
										<th>Zweck</th>
										<th>Cookie-Dauer</th>
										<th>Anbieter</th>
									</tr>
									<tr>
										<td>ARRAffinity</td>
										<td>Gewährleistet die ordnungsgemäße Funktion von MS Azure</td>
										<td>Bis zum Schließen des Browsers</td>
										<td>Microsoft Azure</td>
									</tr>
									<tr>
										<td>ARRAffinitySameSite</td>
										<td>Gewährleistet die ordnungsgemäße Funktion von MS Azure</td>
										<td>Bis zum Schließen des Browsers</td>
										<td>Microsoft Azure</td>
									</tr>
									<tr>
										<td>cookie_viewed</td>
										<td>Speichert, ob der Besucher die Cookie-Benachrichtigung gesehen hat</td>
										<td>365 Tage</td>
										<td>Varialis</td>
									</tr>
								</table>
							</Col>
						</Row>
					</Col>
				</Row>
			) : lang === 'fr' ? (
				<Row form>
					<Col md={8}>
						<Row form>
							<Col md={12} style={{ paddingBottom: '20px' }}>
								<h1>{locale.cookiesTitle}</h1>
								<p>
									Ce site web utilise des cookies pour son fonctionnement, qui ne stockent pas de données personnelles et ne suivent pas votre
									comportement en dehors de la connexion avec le site web. Ces cookies sont nécessaires pour garantir une expérience utilisateur
									fiable et sécurisée. En utilisant le site web, les visiteurs acceptent l'utilisation de ces cookies.
								</p>
							</Col>
						</Row>
						<Row form>
							<Col md={12} style={{ paddingBottom: '20px' }}>
								<h2>À propos des cookies</h2>
								<p>
									Les cookies ne sont pas nouveaux. Tous les visiteurs des sites web ont déjà de nombreux cookies stockés sur leurs ordinateurs,
									tablettes et téléphones mobiles provenant de différents sites. La nouveauté réside dans le fait qu'avec la nouvelle législation
									(ZEKom-1), des changements ont été introduits concernant l'information et le consentement des visiteurs à leur utilisation.
								</p>
							</Col>
						</Row>
						<Row form>
							<Col md={12} style={{ paddingBottom: '20px' }}>
								<h2>Que sont les cookies ?</h2>
								<p>
									Les cookies sont de petits fichiers texte que la plupart des sites web stockent sur les appareils utilisés par les utilisateurs pour
									accéder à Internet. Leur objectif est de reconnaître les appareils individuels utilisés lors de l'accès. Le stockage des cookies est
									entièrement contrôlé par le navigateur de l'utilisateur – celui-ci peut limiter ou désactiver le stockage des cookies à sa guise.
									Les cookies ne sont pas nuisibles et sont toujours limités dans le temps.
								</p>
							</Col>
						</Row>
						<Row form>
							<Col md={12} style={{ paddingBottom: '20px' }}>
								<h2>Pourquoi les cookies sont-ils nécessaires ?</h2>
								<p>
									Les cookies sont essentiels pour offrir des services en ligne conviviaux et une expérience utilisateur fiable et sécurisée.
									L'interaction entre un utilisateur web et un site web est plus rapide et plus facile grâce aux cookies.
								</p>
								<p>
									<b>Quelques exemples concrets d'utilisation des cookies :</b>
								</p>
								<ul>
									<li style={{ paddingBottom: '10px' }}>
										<b>Pour une meilleure expérience utilisateur sur le site web : </b>Nous veillons à ce que vos demandes pendant votre visite sur
										notre site soient toujours envoyées au même serveur. Cela garantit la cohérence de vos données de session (par exemple, état de
										connexion ou préférences), et le site fonctionne de manière plus efficace sans redirections ni interruptions inutiles.
									</li>
									<li style={{ paddingBottom: '10px' }}>
										<b>Pour une expérience utilisateur sécurisée : </b>Le cookie est envoyé uniquement pour les demandes provenant directement de
										notre site web. Cela garantit une protection contre les demandes non autorisées provenant d'autres sites.
									</li>
								</ul>
								<p>
									<b>Notre site web utilise les cookies nécessaires (fonctionnels) suivants :</b>
								</p>
								<table>
									<tr>
										<th>Nom du cookie</th>
										<th>Objectif</th>
										<th>Durée du cookie</th>
										<th>Fournisseur</th>
									</tr>
									<tr>
										<td>ARRAffinity</td>
										<td>Garantit le bon fonctionnement de MS Azure</td>
										<td>Jusqu'à la fermeture du navigateur</td>
										<td>Microsoft Azure</td>
									</tr>
									<tr>
										<td>ARRAffinitySameSite</td>
										<td>Garantit le bon fonctionnement de MS Azure</td>
										<td>Jusqu'à la fermeture du navigateur</td>
										<td>Microsoft Azure</td>
									</tr>
									<tr>
										<td>cookie_viewed</td>
										<td>Stocke l'information indiquant si le visiteur a vu la notification relative aux cookies</td>
										<td>365 jours</td>
										<td>Varialis</td>
									</tr>
								</table>
							</Col>
						</Row>
					</Col>
				</Row>
			) : lang === 'hr' ? (
				<Row form>
					<Col md={8}>
						<Row form>
							<Col md={12} style={{ paddingBottom: '20px' }}>
								<h1>{locale.cookiesTitle}</h1>
								<p>
									Ova web stranica koristi kolačiće za svoje funkcioniranje, koji ne pohranjuju osobne podatke i ne prate vaše ponašanje izvan
									održavanja veze s web stranicom. Ovi su kolačići potrebni za osiguravanje pouzdanog i sigurnog korisničkog iskustva. Korištenjem web
									stranice, posjetitelji pristaju na upotrebu ovih kolačića.
								</p>
							</Col>
						</Row>
						<Row form>
							<Col md={12} style={{ paddingBottom: '20px' }}>
								<h2>O kolačićima</h2>
								<p>
									Kolačići nisu ništa novo. Svi posjetitelji web stranica već imaju mnogo kolačića pohranjenih na svojim računalima, tabletima i
									mobitelima s različitih web stranica. Novost je u tome što su s novim zakonodavstvom (ZEKom-1) uvedene promjene vezane za
									informiranje i pristajanje posjetitelja na njihovu upotrebu.
								</p>
							</Col>
						</Row>
						<Row form>
							<Col md={12} style={{ paddingBottom: '20px' }}>
								<h2>Što su kolačići?</h2>
								<p>
									Kolačići su male tekstualne datoteke koje većina web stranica pohranjuje na uređaje kojima korisnici pristupaju internetu. Njihova
									svrha je prepoznavanje pojedinih uređaja koje su korisnici koristili pri pristupu. Pohrana kolačića potpuno je pod kontrolom
									preglednika koji korisnik koristi – korisnik može ograničiti ili onemogućiti pohranu kolačića prema želji. Kolačići nisu štetni i
									uvijek su vremenski ograničeni.
								</p>
							</Col>
						</Row>
						<Row form>
							<Col md={12} style={{ paddingBottom: '20px' }}>
								<h2>Zašto su kolačići potrebni?</h2>
								<p>
									Kolačići su ključni za pružanje korisnički prilagođenih online usluga te pouzdanog i sigurnog korisničkog iskustva. Interakcija
									između web korisnika i web stranice brža je i jednostavnija uz pomoć kolačića.
								</p>
								<p>
									<b>Neki konkretni primjeri upotrebe kolačića:</b>
								</p>
								<ul>
									<li style={{ paddingBottom: '10px' }}>
										<b>Za bolje korisničko iskustvo na web stranici: </b>Omogućujemo da se vaši zahtjevi tijekom posjeta našoj web stranici uvijek
										šalju na isti poslužitelj. Time osiguravamo dosljednost podataka vaše sesije (npr. status prijave ili postavke), a web stranica
										radi učinkovitije bez nepotrebnih preusmjeravanja ili prekida.
									</li>
									<li style={{ paddingBottom: '10px' }}>
										<b>Za sigurno korisničko iskustvo: </b>Kolačić se šalje samo za zahtjeve koji dolaze izravno s naše web stranice, čime se
										osigurava zaštita od neovlaštenih zahtjeva s drugih web stranica.
									</li>
								</ul>
								<p>
									<b>Naša web stranica koristi sljedeće nužne (funkcionalne) kolačiće:</b>
								</p>
								<table>
									<tr>
										<th>Naziv kolačića</th>
										<th>Svrha</th>
										<th>Trajanje kolačića</th>
										<th>Pružatelj</th>
									</tr>
									<tr>
										<td>ARRAffinity</td>
										<td>Osigurava ispravno funkcioniranje MS Azurea</td>
										<td>Do zatvaranja preglednika</td>
										<td>Microsoft Azure</td>
									</tr>
									<tr>
										<td>ARRAffinitySameSite</td>
										<td>Osigurava ispravno funkcioniranje MS Azurea</td>
										<td>Do zatvaranja preglednika</td>
										<td>Microsoft Azure</td>
									</tr>
									<tr>
										<td>cookie_viewed</td>
										<td>Koristi se za pohranu informacije o tome je li posjetitelj vidio obavijest o kolačićima</td>
										<td>365 dana</td>
										<td>Varialis</td>
									</tr>
								</table>
							</Col>
						</Row>
					</Col>
				</Row>
			) : (
				<p>Language not supported</p>
			)}
		</Container>
	);
};
export default CookieInfo;
